// extracted by mini-css-extract-plugin
export default {"delete-img":"DeleteImg_delete-img__lkuH0","delete-spn":"DeleteImg_delete-spn__jIOoQ"};